<template v-if="imagePth">
  <div>
    <div v-if="shouldShowDialog" class="overlay" @click="closeDialog"></div>
    <div v-if="shouldShowDialog" class="dialog">
      <div class="dialog-content">
        <span class="close" @click="closeDialog">&times;</span>
        <div>
          <img :src="imagePth" class="responsive-image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imagePth: String
  },
  data() {
    return {
      shouldShowDialog: true
    };
  },
  methods: {
    closeDialog() {
      this.shouldShowDialog = false;
    }
  }
};
</script>

<style scoped>
.responsive-image {
  max-width: 80vw;
  max-height: 70vh;
  object-fit: contain; 
}

/* Add your overlay styles here */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3; 
}

.dialog {
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 4;
}

.dialog-content {
  /* Add styles for dialog content */
}

 .close {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  background: none;
  border: none;
  position: absolute;
  top: 0px;
  right: 0px;  
}
</style>
